import * as React from 'react';
import { Button } from '@roo/roo';
import './index.scss';

function NotProvider() {
    function settleIn() {
        window.location.href = 'https://wenjuan.meituan.com/survey/536498';
    }
    return (
        <div className="notProvider">
            <img src="../imgs/empty-store.png" alt="" />
            <p className="txt">抱歉，您还不是服务市场的服务商，如想入驻请填写入驻问卷</p>
            <Button onClick={settleIn}>立即入驻</Button>
        </div>
    );
}

export default NotProvider;
